module.exports = __webpack_public_path__ + "static/media/vampiro.9cd9d03a.jpg";